import { render, staticRenderFns } from "./BaseSignBlock.vue?vue&type=template&id=0496fd62&scoped=true&"
import script from "./BaseSignBlock.vue?vue&type=script&lang=js&"
export * from "./BaseSignBlock.vue?vue&type=script&lang=js&"
import style0 from "./BaseSignBlock.vue?vue&type=style&index=0&id=0496fd62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496fd62",
  null
  
)

export default component.exports